import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NewRequestErrorSnackbarComponent } from '../components/new-request-error-snackbar/new-request-error-snackbar.component';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnackAlertService {
  dataList: any[] = [];
  viewCustomSnackBar: boolean = true;

  constructor(private readonly snackAlert: MatSnackBar) {}

  openSnackBar(
    message: string,
    panelClass?: string,
    duration?: number,
    closeButton?: string,
    showCloseButton?: boolean
  ): void {
    const options: MatSnackBarConfig = {
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      announcementMessage: message,
      duration: duration ?? 0, // To prevent auto-dismissal
    };
    this.viewCustomSnackBar = true;
    if (panelClass) {
      options.panelClass = [panelClass];
    }

    if (showCloseButton) {
      options.panelClass = ['error-snackbar'];
      options.announcementMessage = message + ' ';
      options.duration = 0;
      options.panelClass.push('show-close-button');
    }

    const snackBarRef = this.snackAlert.open(
      message,
      closeButton ?? '',
      options
    );

    if (showCloseButton) {
      snackBarRef.onAction().subscribe(() => {
        snackBarRef.dismiss();
      });
    }
    snackBarRef.afterDismissed().subscribe((close) => {
      this.viewCustomSnackBar && this.viewErrorNewRequest();
    });
  }

  openErrorNewRequest(message: string, formData: FormData) {
    this.viewCustomSnackBar = false;
    this.dataList.push({ message, formData });
    this.viewErrorNewRequest();
  }

  viewErrorNewRequest() {
    if (this.dataList.length > 0) {
      const onClose$: Subject<boolean> = new Subject();
      this.snackAlert.openFromComponent(NewRequestErrorSnackbarComponent, {
        duration: 0,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar', 'error-custom-snackbar'],
        data: {
          dataList: this.dataList,
          onClose$,
        },
      });
      onClose$.subscribe((close) => {
        if (close) {
          this.viewCustomSnackBar = true;
        }
      });
    }
  }

  closeAll() {
    this.snackAlert.dismiss();
  }
}